<template>
  <form-section>
    <el-row>
      <el-col :span="24">
        <rest-form-item prop="title" :label="$t('ProjectSettings_Field_Title')">
          <el-input v-model="value.title" data-qa="title" />
        </rest-form-item>
      </el-col>
    </el-row>
    <el-row v-if="isAdmin">
      <el-col :span="12">
        <rest-form-item
          prop="provider_id"
          :label="$t('ProjectSettings_Field_Provider')"
        >
          <el-select
            v-model="value.provider_id"
            @change="delete value.company_id"
            data-qa="provider"
          >
            <el-option
              v-for="provider in providers"
              :key="provider.id"
              :value="provider.id"
              :label="provider.title"
            >
              {{ provider.title }} ({{ provider.id }})
            </el-option>
          </el-select>
        </rest-form-item>
      </el-col>
      <el-col :span="12">
        <rest-form-item
          prop="company_id"
          :label="$t('ProjectSettings_Field_Company')"
        >
          <el-select
            v-model="value.company_id"
            :disabled="!value.provider_id"
            data-qa="company"
          >
            <el-option
              v-for="company in companiesByProvider"
              :key="company.id"
              :value="company.id"
              :label="company.name"
            >
              {{ company.name }} ({{ company.id }})
            </el-option>
          </el-select>
        </rest-form-item>
      </el-col>
    </el-row>
    <el-row>
      <el-col :span="12">
        <rest-form-item
          prop="timezone"
          :label="$t('ProjectSettings_Field_Timezone')"
        >
          <el-select
            v-model="value.timezone"
            :disabled="!isCreatePage"
            filterable
            data-qa="timezone"
          >
            <el-option
              v-for="(time, index) in timezones"
              :key="index"
              :value="index"
            >
              {{ time }}
            </el-option>
          </el-select>
        </rest-form-item>
      </el-col>
      <el-col :span="12">
        <rest-form-item
          prop="region"
          :label="$t('ProjectSettings_Field_Region')"
        >
          <el-select v-model="value.region" :disabled="true" data-qa="region">
            <el-option
              :value="value.region"
              :label="value.region.toUpperCase()"
            />
          </el-select>
        </rest-form-item>
      </el-col>
    </el-row>
    <el-row v-if="isAdmin">
      <el-col :span="12">
        <rest-form-item
          :label="$t('ProjectSettings_Field_MobileApiLogs')"
          prop="mobile_api_logs"
        >
          <el-select v-model="value.mobile_api_logs" data-qa="mobile_api_logs">
            <el-option
              v-for="item in logOptions"
              :key="item.value"
              :value="item.value"
              :label="item.label"
            />
          </el-select>
        </rest-form-item>
      </el-col>
      <el-col :span="12">
        <rest-form-item
          :label="$t('ProjectSettings_Field_ExternalApiLogs')"
          prop="external_api_logs"
        >
          <el-select
            v-model="value.external_api_logs"
            data-qa="external_api_logs"
          >
            <el-option
              v-for="item in logOptions"
              :key="item.value"
              :value="item.value"
              :label="item.label"
            />
          </el-select>
        </rest-form-item>
      </el-col>
    </el-row>
    <el-row>
      <el-col :span="12">
        <rest-form-item
          prop="description"
          :label="$t('ProjectSettings_Field_Description')"
        >
          <el-input
            type="textarea"
            class="description"
            v-model="value.description"
            data-qa="description"
          />
        </rest-form-item>
      </el-col>
      <el-col :span="12">
        <rest-form-item prop="icon" :label="$t('ProjectSettings_Field_Icon')">
          <icon-upload
            :value="value.icon"
            :file.sync="value.icon_file"
            accepts=".gif,.jpg,.jpeg,.png,.ico"
            size="large"
            data-qa="icon"
          />
        </rest-form-item>
      </el-col>
    </el-row>
  </form-section>
</template>

<script>
import FormSection from '@/common/components/form/FormSection'
import RestFormItem from '@/common/components/rest/RestFormItem'
import IconUpload from '@/common/components/form/IconUpload'

export default {
  name: 'ProjectSettingsSection',
  components: { IconUpload, RestFormItem, FormSection },
  data() {
    return {
      logOptions: [
        { value: 0, label: this.$t('ProjectSettings_Logs_Off') },
        { value: 1, label: this.$t('ProjectSettings_Logs_On') },
        { value: 2, label: this.$t('ProjectSettings_Logs_Batched') }
      ]
    }
  },
  props: {
    value: {
      type: Object,
      required: true
    },
    companies: {
      required: true
    },
    providers: {
      required: true
    },
    timezones: {
      required: true
    }
  },
  computed: {
    isAdmin() {
      return (
        this.$isRole('admin') ||
        this.$isRole('admin-support') ||
        this.$isRole('admin-viewer') ||
        this.$isRole('provider-admin') ||
        this.$isRole('provider-admin-viewer')
      )
    },
    companiesByProvider() {
      return this.companies.filter(
        company => company.provider_id === this.value.provider_id
      )
    },
    isCreatePage() {
      return !this.$route.query.project_id
    }
  }
}
</script>

<style scoped>
.description >>> .el-textarea__inner {
  height: 150px;
}
</style>



// WEBPACK FOOTER //
// src/modules/project/components/ProjectSettingsSection.vue